
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaidarshancabs() {



    const cardData =
    {
        keyword: ' Mumbai Darshan Cabs',
        heading: 'Skyline Cabs:  Mumbai Darshan Cabs',
        headingDescription: 'Skyline Cabs offers comfortable and convenient Mumbai Darshan Cabs for a memorable sightseeing experience across the City of Dreams. Whether you are visiting with family, friends, or tourists from out of town, our well-maintained vehicles and knowledgeable drivers ensure you explore Mumbai’s top attractions in comfort and style. From Gateway of India and Marine Drive to Siddhivinayak Temple and Juhu Beach, enjoy a customized tour with flexible timings, transparent pricing, and 24/7 support. Book your Mumbai Darshan cab today with Skyline Cabs and discover the best of Mumbai stress-free!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Mumbai Darshan Cab Service",
      "description": "Explore the vibrant city of Mumbai with Skyline Cabs' Mumbai Darshan cab service. Perfect for families, tourists, or groups, we offer well-planned routes, experienced drivers, and comfortable vehicles for a hassle-free city tour."
    },
    {
      "name": "Mumbai Sightseeing Cab",
      "description": "Skyline Cabs offers sightseeing cabs for Mumbai tours. Discover top attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, and more in comfort. Flexible half-day and full-day packages available."
    },
    {
      "name": "Mumbai City Tour Cab",
      "description": "Take a comprehensive Mumbai city tour with our well-maintained cabs. Skyline Cabs ensures you visit all must-see landmarks with the help of professional drivers who know the best routes and tourist hotspots."
    },
    {
      "name": "Mumbai Darshan One Day Trip",
      "description": "Book a one-day Mumbai Darshan trip with Skyline Cabs. Ideal for tourists who want to make the most of their day, this service covers iconic places like Haji Ali, Juhu Beach, Colaba Causeway, and more."
    },
    {
      "name": "Mumbai Darshan Taxi Booking",
      "description": "Easily book a Mumbai Darshan taxi online or via phone with Skyline Cabs. We offer transparent pricing, customizable routes, and a variety of vehicle options to suit all group sizes and budgets."
    },
    {
      "name": "Mumbai City Tour Taxi",
      "description": "Our Mumbai city tour taxi service is designed to give you a relaxing and enriching sightseeing experience. From colonial heritage to Bollywood hotspots, our tours cover it all."
    },
    {
      "name": "Taxi Service for Mumbai Darshan",
      "description": "Skyline Cabs provides expert taxi services for Mumbai Darshan. Choose from sedans, SUVs, or tempo travelers based on your group size, and enjoy an informative and comfortable city tour."
    },
    {
      "name": "Best Mumbai Darshan Taxi",
      "description": "Skyline Cabs is rated among the best for Mumbai Darshan taxis. Our packages include expert chauffeurs, clean cars, and curated sightseeing plans to ensure an enjoyable city experience."
    },
    {
      "name": "Mumbai Local Tour Taxi",
      "description": "Book Mumbai local tour taxis with Skyline Cabs for a flexible and personalized travel experience. Whether you're a solo traveler or a group, our city tours are crafted for comfort and convenience."
    }
  ],
  "tableData": [
    ["Mumbai Darshan Cab Service", "Mumbai Sightseeing Cab"],
    ["Mumbai City Tour Cab", "Mumbai Darshan One Day Trip"],
    ["Mumbai Darshan Taxi Booking", "Mumbai City Tour Taxi"],
    ["Taxi Service for Mumbai Darshan", "Best Mumbai Darshan Taxi"],
    ["Mumbai Local Tour Taxi", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai Darshan Cab Service",
        "WhyChoosedescription": "Experience a reliable and comfortable Mumbai Darshan cab service, offering punctual and hassle-free rides to explore the city's top attractions and landmarks."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Cabs",
        "WhyChoosedescription": "Our Mumbai Darshan cabs are designed for comfort with spacious interiors, ensuring a pleasant ride for you and your group while touring Mumbai."
    },
    {
        "WhyChooseheading": "Perfect for City Exploration",
        "WhyChoosedescription": "Explore Mumbai’s iconic landmarks in style. Our cabs are ideal for city sightseeing, whether you’re visiting historical sites, cultural hubs, or enjoying a scenic drive along the coast."
    },
    {
        "WhyChooseheading": "Experienced and Friendly Drivers",
        "WhyChoosedescription": "Our drivers are local experts who know the best routes and attractions in Mumbai, ensuring you have an informative, safe, and smooth journey throughout your Darshan tour."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive and transparent pricing for Mumbai Darshan cabs with no hidden fees. Enjoy an affordable and straightforward experience during your sightseeing tour."
    },
    {
        "WhyChooseheading": "Flexible Tour Packages",
        "WhyChoosedescription": "Choose from hourly, half-day, or full-day packages to tailor your Mumbai Darshan trip. Whether you want a quick tour or an extended experience, we provide options that suit your schedule."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Booking your Mumbai Darshan cab is easy, with 24/7 customer support available online or over the phone. Enjoy a seamless booking experience with instant confirmation."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our cabs are regularly sanitized and well-maintained to ensure a safe, clean, and comfortable ride for all passengers during their Mumbai sightseeing journey."
    }
]











    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai Darshan cab with Skyline Cabs?',
            answer:
                'Booking a Mumbai Darshan cab is simple with Skyline Cabs. You can book via our website, mobile app, or by calling customer support. Just choose your preferred vehicle, select "Mumbai Darshan" as your trip type, and confirm the date and pickup time.',
        },
        {
            id: 2,
            question: 'What places are covered in the Mumbai Darshan tour?',
            answer:
                'Our Mumbai Darshan packages typically include iconic attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, Haji Ali Dargah, Bandra-Worli Sea Link, and more. Custom itineraries can also be arranged upon request.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai Darshan?',
            answer:
                'We offer a wide range of vehicles for Mumbai Darshan including Sedans, SUVs, Ertiga, Innova Crysta, and Tempo Travellers to suit different group sizes and comfort preferences.',
        },
        {
            id: 4,
            question: 'Are the Mumbai Darshan cab fares fixed?',
            answer:
                'Yes, we provide fixed pricing for Mumbai Darshan tours. The fare includes the vehicle, fuel, driver charges, and parking. There are no hidden charges.',
        },
        {
            id: 5,
            question: 'Can I customize my Mumbai Darshan itinerary?',
            answer:
                'Absolutely! You can customize your Mumbai Darshan route according to your interests and time. Just inform us in advance, and we’ll tailor the experience for you.',
        },
        {
            id: 6,
            question: 'Are the cabs clean and drivers experienced for Mumbai Darshan?',
            answer:
                'Yes, all our cabs are well-maintained and sanitized. Our drivers are experienced locals who know the city well and can also serve as informal guides during the tour.',
        },
        {
            id: 7,
            question: 'Can I book a half-day or full-day Mumbai Darshan cab?',
            answer:
                'Yes, Skyline Cabs offers both half-day and full-day Mumbai Darshan packages. Choose the one that best suits your schedule and interests.',
        },
        {
            id: 8,
            question: 'What payment options are available for Mumbai Darshan cabs?',
            answer:
                'You can pay online via UPI, debit/credit cards, net banking, or in cash at the end of your tour. All online payments are secure and easy.',
        },
        {
            id: 9,
            question: 'Is advance booking required for Mumbai Darshan?',
            answer:
                'While we accept same-day bookings subject to availability, we recommend booking in advance to secure your preferred vehicle and time slot.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for Mumbai Darshan?',
            answer:
                'Skyline Cabs offers reliable service, knowledgeable drivers, clean vehicles, and customized routes to make your Mumbai Darshan experience smooth and memorable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked a Mumbai Darshan cab with Skyline Cabs and it was a wonderful experience. The driver knew all the major spots and helped us plan our day well. Highly recommend!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a great day touring Mumbai with Skyline Cabs. The cab was clean, driver was friendly, and the whole day went smoothly. Perfect for first-time visitors!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-darshan-cabs.jpg",
  "description": "Book Mumbai Darshan cabs with Skyline Cabs for a comfortable, guided sightseeing experience across iconic spots like Gateway of India, Marine Drive, Juhu Beach, and more. AC sedans, SUVs, and tempo travellers available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8776"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-darshan-cabs"
  }
};



      
     
      


    return (
        <div>

<Helmet>
  <title>Mumbai Darshan Cabs | Sightseeing Taxi Packages | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Darshan cabs with Skyline Cabs for a comfortable, guided sightseeing experience across iconic spots like Gateway of India, Marine Drive, Juhu Beach, and more. AC sedans, SUVs, and tempo travellers available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Darshan Cabs, Sightseeing Taxi Mumbai, Gateway of India Cab Tour, Mumbai One Day Tour Taxi, AC Cab for Mumbai Darshan, Marine Drive Cab, Mumbai Darshan by Car, Skyline Cabs Mumbai, Juhu Beach Cab, Mumbai City Tour Cabs" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/78.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaidarshancabs;